import "../10. Battle/Library/LibraryBoxBattle.scss";
import Control from "../1. Core/Control";
import NP, {ValueChangedEventArgs} from "../1. Core/NP";
import TopAppBar from "../1. Core/Controls/TopAppBar/TopAppBar";
import Delegate from "../1. Core/Delegate";
import {ServerAPI} from "../1. Core/ServerAPI";
import DataTable, {IColumnDataTable} from "../1. Core/Controls/DataTable/DataTable";
import AthletesFilterPanel from "./AthletesFilterPanel";

import AthletesInfoPanel from "../10. Battle/Library/Panels/AthleteInfoPanel";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import Button from "../1. Core/Controls/Button/Button";
import {getInternalWidgets, getTournaments, getWeightStringById, ITournament, titleCaseWord} from "../10. Battle/Util";
import EditAthleteDialog from "./EditAthleteDialog";
import Menu from "../1. Core/Controls/Menu/Menu";
import Dialog from "../1. Core/Controls/Dialog/Dialog";

import './AthletesList.scss';
import BoxerDashboard from "../10. Battle/Analytics/BoxerDashboard";
import MmaAthleteDashboard from "../10. Battle/Analytics/MmaAthleteDashboard";
import {AthleteRating, getSportType, IAthlete, PageMode, SportType} from "../10. Battle/types";
import SimpleAthletesList from "./SimpleAthletesList";
import AthleteHLListDialog from "./AthleteHLListDialog";
import FighterStatWidgetEditDialog
	from "../10. Battle/WidgetManager/FighterStatWidgetEditDialog/FighterStatWidgetEditDialog";
import FighterCardWidgetEditDialog
	from "../10. Battle/WidgetManager/FighterCardWidgetEditDialog/FighterCardWidgetEditDialog";
import FighterRecordWidgetEditDialog
	from "../10. Battle/WidgetManager/FighterRecordWidgetEditDialog/FighterRecordWidgetEditDialog";


export interface IAthleteListItem {
	Athlete: IAthlete,
	Image: string,
	Name: string,
	State?: string,
	WeightCat: string,
	Rating: number,
	Country: string;
	BoutsCount?: number;
	RecordInfo: string
}

interface IAthleteFiltersSort {
	FilterText?: string,
	TournamentId?: string,
	StateId?: number,
	Sex?: number,
	WeightCategory?: number,
	SortField?: string,
	SortDirection?: number,
	TrainerId?: number
	SportCategory?: string
}

export default class AthletesList extends Control {
	private _OpenedItemId: number;
	private _Count: number;
	private _Offset: number;
	private _DrillDownFilter: IAthleteFiltersSort;
	private _topAppBar: TopAppBar;
	private _FilterText: string;
	private EvShowPageModeClick: Delegate;
	private EvPageModeChanged: Delegate;
	private EvAthleteOpened: Delegate;
	private _Athletes: IAthleteListItem[];
	private _dataTable: DataTable;
	private _filtersPanel: AthletesFilterPanel;
	private _infoPanel: AthletesInfoPanel;

	private _dataWithFiltersNode: HTMLElement;
	private _dashWithInfoNode: HTMLElement;

	private _athleteInfoView: BoxerDashboard;
	private _mmaAthleteInfoView: MmaAthleteDashboard;
	private _AllCount: number;
	private _CurrentFilter: IAthleteFiltersSort;

	private _Mode: PageMode
	private _UseCity: boolean;
	private _ShowCategory: boolean;
	private _TournamentId: number;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._ShowCategory = false;
		this._UseCity = false;
		this.EvShowPageModeClick = new Delegate();
		this.EvPageModeChanged = new Delegate();
		this.EvAthleteOpened = new Delegate();
		this._DrillDownFilter = null;
		this._OpenedItemId = null;
		this._FilterText = '';
		this._Mode = null;
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();
		this.addClass(' athletes-list');
		this._Count = 100;
		this._Offset = 0;

		this._topAppBar = new TopAppBar({
			Class: 'athletes-list__top-app-bar top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: NP.RM.getString('Athletes'),
			ParentNode: this._root,
			EvSearch: (s: Control, e: ValueChangedEventArgs) =>
			{
				this._FilterText = e.Value;
				this._Offset = 0;
				this._AllCount = null;
				this._refreshList();
			},
			EvHideSearch: () =>
			{
				this._Offset = 0;
				this._AllCount = null;
				this._FilterText = null;
				this._refreshList();
			},
			ShowSearchButton: true,
			MainButton: {
				FontImage: NP.FontImages.menu,
				EvClick: () => this.EvShowPageModeClick.fire(this)
			},
			CustomMainButton: this._DrillDownFilter
				 ? new Button({
					 Class: 'top-app-bar__title breadcrumb-root',
					 Content: NP.RM.getString('States'),
					 EvClick: () => this.EvPageModeChanged.fire(this)
				 })
				 : null,
			EvFocusSearch: () =>
			{
			}
		});

		if (!this._DrillDownFilter && NP.isAdmin())
			this._topAppBar.addItem(new IconToggleButton({
				FontImage: NP.FontImages.add,
				Value: 'AddBoxer',
				EvClick: () => (new EditAthleteDialog({
					SportType: getSportType(this._Mode),
					EvOkButtonClick: () => this._refreshList()
				})).refresh().show()
			}));

		this._topAppBar.addItem(new IconToggleButton({
			FontImage: NP.FontImages.tune,
			Value: 'Filters',
			EvClick: (btn: IconToggleButton) =>
			{
				btn.setData(!btn.getData())
				if (this._root.contains(this._dashWithInfoNode))
					this._infoPanel.setIsVisible(!this._infoPanel.getIsVisible());
				else
					this._filtersPanel.setIsVisible(!this._filtersPanel.getIsVisible());
			}
		}));

		this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');

		this._dashWithInfoNode = NP.createNode(document.documentElement, 'athletes-list__dash-with-info-container dash-with-info-container');


		let cols: IColumnDataTable[];

		if (this._Mode == PageMode.mmaathletes)
			cols = [{
				Content: NP.RM.getString('Name'),
				PropertyContent: 'Name'
			},  {
				Content: NP.RM.getString(this._UseCity ? 'City' : 'Country'),
				PropertyContent: 'Country',
			}, NP.isAdmin() && {
				Content: NP.RM.getString('MMARating'),
				PropertyContent: 'Rating',
			}, {
				Content: NP.RM.getString('RecordInfo'),
				PropertyContent: 'RecordInfo',
			}] as IColumnDataTable[]
		else
			cols = [{
				Content: NP.RM.getString('Name'),
				PropertyContent: 'Name'
			}, {
				Content: NP.RM.getString(this._UseCity ? 'City' : 'Country'),
				PropertyContent: 'Country',
			}, {
				Content: NP.RM.getString('WeightCategory'),
				PropertyContent: 'WeightCat',
			}, {
				Content: NP.RM.getString('RecordInfo'),
				PropertyContent: 'RecordInfo',
			}] as IColumnDataTable[]


		if (this._Mode == PageMode.boxers)
			cols.push({
				Content: NP.RM.getString('Points'),
				PropertyContent: 'Points',
			} as IColumnDataTable);


		if (this._ShowCategory)
			cols.push({
				Content: NP.RM.getString('SportCategory'),
				PropertyContent: 'SportCategory',
			} as IColumnDataTable)

		cols = cols.filter(c => !!c)

		cols.forEach(c => c.Width = (100 / cols.length) + '%')


		this._dataTable = new DataTable({
			ParentNode: this._dataWithFiltersNode,
			ShowSettingsButton: true,
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: true,
			ImageWidth: 32,
			Columns: cols,
			ShowPaginator: true,
			EvSortClick: (s: DataTable, e: any) =>
			{
				e.CanceSort = true;

				switch (e.Column)
				{
					case 0:
						if (this._DrillDownFilter)
							this._DrillDownFilter.SortField = 'Name';
						else
							this._filtersPanel.setSortValues('Name', e.Direction);
						break;
					case 1:
						if (this._DrillDownFilter)
							this._DrillDownFilter.SortField = 'Country';
						else
							this._filtersPanel.setSortValues('Country', e.Direction);
						break;
					case 2:
						if (this._DrillDownFilter)
							this._DrillDownFilter.SortField = 'Weight';
						else
							this._filtersPanel.setSortValues('Weight', e.Direction);
						break;
					case 3:
						if (this._DrillDownFilter)
							this._DrillDownFilter.SortField = 'BoutsCount';
						else
							this._filtersPanel.setSortValues('BoutsCount', e.Direction);
						break;
				}

				if (this._DrillDownFilter)
					this._DrillDownFilter.SortDirection = e.Direction;

				this._Offset = 0;

				this._refreshList();
			},
			EvPaginatorLeftClick: () =>
			{
				this._Offset -= this._Count;
				this._refreshList();
			},
			EvItemClick: (s: object, e: { Item: IAthleteListItem }) =>
			{
				let athlete = e.Item.Athlete;
				this.EvAthleteOpened.fire(this, {Athlete: athlete})
				this.showAthleteInfoView(athlete);
			},
			EvPaginatorRightClick: () =>
			{
				this._Offset += this._Count;
				this._refreshList();
			},
			EvItemContextMenu: async (s: any, e: { Event: any, Item: IAthleteListItem }) =>
			{
				let items = [];

				if (NP.isAdmin())
				{
					items.push({
							 FontImage: NP.FontImages.edit,
							 RK: 'Edit',
							 Value: 'Edit',
							 EvClick: () => (new EditAthleteDialog({
								 Athlete: e.Item.Athlete,
								 SportType: getSportType(this._Mode),
								 EvOkButtonClick: () => this._refreshList()
							 })).refresh().show()
						 }, {
							 FontImage: NP.FontImages.fullscreen,
							 Content: 'HighLights',
							 Value: 'HighLights',
							 EvClick: () => (new AthleteHLListDialog({
								 Athlete: e.Item.Athlete,
							 })).show()
						 }, {
							 FontImage: NP.FontImages.add,
							 Content: 'Create Fighter Stat Widget',
							 EvClick: () => (new FighterStatWidgetEditDialog({
								 SelectedAthlete: e.Item.Athlete,
							 })).show()
						 },
						 {
							 FontImage: NP.FontImages.add,
							 Content: 'Create Fighter Record Widget',
							 EvClick: () => (new FighterRecordWidgetEditDialog({
								 SelectedAthlete: e.Item.Athlete,
							 })).show()
						 },
						 {
							 FontImage: NP.FontImages.add,
							 Content: 'Create Fighter Card Widget',
							 EvClick: () => (new FighterCardWidgetEditDialog({
								 SelectedAthlete: e.Item.Athlete,
							 })).show()
						 },
						 {
							 FontImage: NP.FontImages.calculation,
							 Content: 'Calc rating',
							 EvClick: async () =>
							 {
								 let res = await ServerAPI.post(`/athlete/calcRating/${e.Item.Athlete.Id}`);
								 NP.showMessage({
									 Width: 400,
									 Content: JSON.stringify(res, null, 2),
									 Caption: 'Result'
								 });
							 }
						 },
						 {
							 FontImage: NP.FontImages.edit,
							 RK: 'Union',
							 Value: 'Union',
							 EvClick: () =>
							 {

								 let dlg: Dialog;
								 (dlg = new Dialog({
									 AutoDestroy: true,
									 Content: new SimpleAthletesList({
										 Height: 550 - 64,
										 Mode: this._Mode,
										 EvAthleteSelected: (sender: object, blue: IAthleteListItem) =>
										 {
											 if (blue.Athlete.Id != e.Item.Athlete.Id)
												 NP.showConfirm({
													 Content: `Все перенесётся из <b>${e.Item.Athlete.FirstName} ${e.Item.Athlete.LastName}</b> (${e.Item.Athlete.Id}) в <b>${blue.Name}</b> (${blue.Athlete.Id})`,
													 EvOkButtonClick: async () =>
													 {
														 await ServerAPI.callUiApi(`/athlete/union/${e.Item.Athlete.Id}/${blue.Athlete.Id}`, null, 'POST');
														 dlg.hide();
														 this._refreshList()
													 }
												 })
										 }
									 }),
									 EvSearch: (s: object, e: { Value: string }) =>
									 {
										 dlg.getContent().setFilter(e.Value);
									 },
									 ShowSearch: true,
									 ShowCloseButton: true,
									 Class: 'nopad',
									 Width: 900,
									 Height: 550,
									 ShowButtons: false,
									 ShowHeader: true,
									 Caption: 'Union'
								 })).show();

								 dlg.getContent().refresh();
							 }
						 });
				}

				let widgets = await getInternalWidgets();
				if (widgets && widgets.length > 0)
				{
					let widgetsMenuItems = widgets.filter(x => x.Type == 'Athlete' && x.BattleType == getSportType(this._Mode)).map(x =>
					{
						let item = {
							Content: x.Name,
							FontImage: NP.FontImages.chart,
							EvClick: () =>
							{
								let dlg: Dialog;
								(dlg = new Dialog({
									AutoDestroy: true,
									Content: new SimpleAthletesList({
										Height: 550 - 64,
										Mode: this._Mode,
										EvAthleteSelected: (sender: object, blue: IAthleteListItem) =>
										{
											window.open(`/${x.Page}?red=${e.Item.Athlete.GloryFighterID}&blue=${blue.Athlete.GloryFighterID}&lang=` + NP.getCurrentCulture().Name);
											dlg.hide();
										}
									}),
									EvSearch: (s: object, e: { Value: string }) =>
									{
										dlg.getContent().setFilter(e.Value);
									},
									ShowSearch: true,
									ShowCloseButton: true,
									Class: 'nopad',
									Width: 900,
									Height: 550,
									ShowButtons: false,
									ShowHeader: true,
									Caption: 'Select athlete'
								})).show();

								dlg.getContent().refresh();
							}
						};
						return item;
					});
					items.push(...widgetsMenuItems);

					if (NP.isAdmin())
						items.push({IsSeparator: true}, {
							FontImage: NP.FontImages.delete,
							RK: 'Delete',
							Value: 'Delete',
							EvClick: () =>
							{
								NP.showConfirm({
									Content: NP.RM.getString('DeleteAthleteConf').replace("{0}", e.Item.Athlete.FirstName + " " + e.Item.Athlete.LastName),
									EvOkButtonClick: async () =>
									{
										await ServerAPI.callUiApi("/athlete/" + e.Item.Athlete.Id, null, 'DELETE');
										this._refreshList();
									}
								})
							}
						})
				}
				if (items.length > 0)
				{
					let menu = new Menu({
						Items: items
					});
					menu.showContextMenu(e.Event);
				}
			},
			EvSelectionChanged: () =>
			{
			},
			EvScrolled: (s: DataTable, e: any) => this._onScrolled(s, e)
		});

		this._filtersPanel = new AthletesFilterPanel({
			ParentNode: this._dataWithFiltersNode,
			Width: 280,
			TType: getSportType(this._Mode),
			EvFilterSortChanged: (sender: AthletesFilterPanel, args: IAthleteFiltersSort) =>
			{
				this._Offset = 0;
				this._AllCount = null;
				this._CurrentFilter = args;
				this._refreshList();
			}
		});

		if (this._OpenedItemId != null)
		{
			ServerAPI.callUiApi(`/athlete/${this._OpenedItemId}`).then((athlete: IAthlete) => this.showAthleteInfoView(athlete));
		}
	}

	_onScrolled(s: DataTable, e: any)
	{
		if (e.scroll > 0 && e.isSmall)
			this._topAppBar.addClass('top-app-bar--fixed-scrolled');
		else
			this._topAppBar.removeClass('top-app-bar--fixed-scrolled');
	}

	refresh()
	{
		if (this._DrillDownFilter)
		{
			this._filtersPanel.setIsVisible(false);
			this._CurrentFilter = this._DrillDownFilter;
			this._refreshList();
		}
		else
		{
			getTournaments(getSportType(this._Mode)).then((res: ITournament[]) =>
			{
				if (res.length == 1)
					this._TournamentId = res[0].Id;
				this._refreshList();
			});
		}
		this._onScrolled(null, {
			scroll: 0,
			isSmall: this._dataTable.getIsSmall()
		});
	}

	getCurrentFilter()
	{
		return this._DrillDownFilter || this._filtersPanel.getFilterData();
	}

	_refreshList()
	{
		this._dataTable.setRows([]);


		this._topAppBar.setCaption(NP.RM.getString(this._Mode == PageMode.mmaathletes ? 'MMA Athletes' : 'Athletes'))


		let payload = {
			FilterText: this._FilterText,
			Offset: this._Offset,
			Count: this._Count,
			TournamentId: this._TournamentId,
			...this.getCurrentFilter(),
			SportType: getSportType(this._Mode)
		};

		if (payload.FilterText)
			payload.SortField = null;

		ServerAPI.callUiApi("/athlete/items", payload, 'POST').then((response: { List: IAthlete[], AllCount: number }) =>
		{
			if (response)
			{
				if (!this._AllCount)
					this._AllCount = response.AllCount;

				this._Athletes = response.List.map(el =>
				{
					let name = titleCaseWord(el.LastName);
					if (!name)
						name = titleCaseWord(el.FirstName);
					else
						name = titleCaseWord(el.LastName) + " " + titleCaseWord(el.FirstName);



					let countryName = el.CountryName || "";
					if (this._UseCity)
					{
						countryName = el.City
					}
					else if (countryName && el.State)
					{
						countryName += "/";
						countryName += el.State;
					}

					let rInfo = `${el.AthleteRating.winCount} - ${el.AthleteRating.loseCount} - ${el.AthleteRating.drawCount}`

					if (this._Mode == PageMode.mmaathletes)
					{
						return {
							Athlete: el,
							Name: name.trim(),
							WeightCat: getWeightStringById(el.WeightCategory),
							Country: countryName,
							Rating: 'Total: ' + el.AthleteRating.total + ', TotalRecord: ' + el.AthleteRating.totalRecord,
							SportCategory: el.SportCategory,
							Image: AthletesList.getAthleteImage(el),
							RecordInfo: rInfo
						} as any
					}

					return {
						Athlete: el,
						Name: name.trim(),
						State: el.State ? el.State : '',
						WeightCat: getWeightStringById(el.WeightCategory),
						Rating: el.Rating,
						SportCategory: el.SportCategory,
						Image: AthletesList.getAthleteImage(el),
						Country: countryName,
						RecordInfo: rInfo,
						Points: el.Points || ''
					} as IAthleteListItem
				});

				this._dataTable.setShowPaginator(this._AllCount > this._Count);

				this._dataTable.getRightPagButton().setEnabled(this._Offset + this._Count < this._AllCount);
				this._dataTable.updatePagCaption(`${this._Offset + 1} - ${Math.min(this._Offset + this._Count, this._AllCount)} ${NP.RM.getString("of")} ${this._AllCount}`);
				this._dataTable.getLeftPagButton().setEnabled(this._Offset > 0);

				this._dataTable.setRows(this._Athletes);

				let filter = this.getCurrentFilter();
				if (filter)
					switch (filter.SortField)
					{
						case 'Name':
							this._dataTable.updateSortIndicator(0, filter.SortDirection);
							break;
						case 'Country':
							this._dataTable.updateSortIndicator(1, filter.SortDirection);
							break;
						case 'Weight':
							this._dataTable.updateSortIndicator(2, filter.SortDirection);
							break;
						case 'BoutsCount':
							this._dataTable.updateSortIndicator(3, filter.SortDirection);
							break;
					}
			}
		});
	}

	static getAthleteImage(athlete: IAthlete)
	{
		if (athlete.AvatarUrl || athlete.PhotoUrl)
			return `<img class="letterAvatar" src="${athlete.AvatarUrl || athlete.PhotoUrl}"/>`;
		else
			return `<img class="letterAvatar" src="${AthletesList.getDefaultAthleteImageUrl()}" style="background-color:#9E9E9E"/>`;
	}


	static getDefaultAthleteImageUrl(): string
	{
		return `/static/img/fake_avatar.svg`;
	}

	_getContentHeight()
	{
		return this._Height - this._topAppBar.getOffsetHeight();
	}

	setHeight(value: number)
	{
		super.setHeight(value);
		let h = this._getContentHeight();
		this._dataTable.setHeight(h);
		this._filtersPanel.setHeight(h);
		if (this._infoPanel)
			this._infoPanel.setHeight(h);
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this._dataTable.setWidth(value);
		if (this._dataTable.getIsSmall())
		{
			this._topAppBar.removeClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
		else
		{
			this._topAppBar.addClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}

	getDataTable()
	{
		return this._dataTable;
	}

	showAthleteInfoView(athlete: IAthlete)
	{
		NP.updateBrowserUrlString(true, this._Mode, athlete.Id);

		this._root.removeChild(this._dataWithFiltersNode);

		this._root.appendChild(this._dashWithInfoNode);

		// let athleteName = athlete.FirstName || '';
		// if (athlete.LastName)
		// 	athleteName += ' ' + (athlete.LastName || '');

		if (athlete.SportType == SportType.MMA || athlete.SportType == SportType.KB)
		{
			if (!this._mmaAthleteInfoView)
			{
				this._mmaAthleteInfoView = new MmaAthleteDashboard({
					Class: "athletes-list__mma-athlete-info-view",
					Athlete: athlete,
					ParentNode: this._dashWithInfoNode,
					EvClosed: () => this.closeDash()
				});
			}
			else
			{
				this._mmaAthleteInfoView.show();
				this._mmaAthleteInfoView.setAthlete(athlete);
				this._mmaAthleteInfoView.refreshData();
			}
		}
		else
		{
			if (!this._athleteInfoView)
			{
				this._athleteInfoView = new BoxerDashboard({
					Class: "athletes-list__athlete-info-view",
					Athlete: athlete,
					ParentNode: this._dashWithInfoNode,
					EvClosed: () => this.closeDash()
				});
			}
			else
			{
				this._athleteInfoView.show();
				this._athleteInfoView.setAthlete(athlete);
				this._athleteInfoView.refreshData();
			}
		}

		if (!this._infoPanel)
			this._infoPanel = new AthletesInfoPanel({
				Class: "athletes-list__athlete-info-panel",
				ParentNode: this._dashWithInfoNode,
				Width: 280,
				Height: this._getContentHeight() - 16
			});
		else
			this._infoPanel.show();
		this._infoPanel.refresh(athlete.Id);
	}

	closeDash()
	{
		NP.updateBrowserUrlString(true, this._Mode);
		this._topAppBar.addClass('top-app-bar--no-shadow');
		this._athleteInfoView && this._athleteInfoView.hide();
		this._mmaAthleteInfoView && this._mmaAthleteInfoView.hide();
		this._infoPanel.hide();
		this._root.removeChild(this._dashWithInfoNode);
		this._root.appendChild(this._dataWithFiltersNode);
		this.setHeight(this._Height);
	}
}

